import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { environment } from '@frontendlib/common/providers/environment';
import { ProductAnalyticsService } from '@frontendlib/common/services/product-analytics/product-analytics.service';
import { Button2Component } from '../../components/button/button2.component';

/**
 * The cookie banner for product analytics (the public site's, in the app's look): shown while product analytics
 * asks, and its two answers are the only way out, so leaving it unanswered keeps analytics off.
 */
@Component({
  selector: 'app-product-analytics-consent',
  templateUrl: './product-analytics-consent.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Button2Component],
})
export class ProductAnalyticsConsentComponent {
  protected readonly analytics = inject(ProductAnalyticsService);
  protected readonly cookiePolicyUrl = `${environment.landingUrl}/privacy#cookies`;
}
